import renderUtils from "../../helpers/renderUtils";
import QrCodeButton from "../../components/qrCode/QrCodeButton";
import React from "react";
import {SecondaryOutlineBadge} from "../../components/badge/SecondaryOutlineBadge";
import IconButton from "../../components/button/IconButton";
import { useModels } from "../../helpers/models";
import {useHistory} from "react-router-dom";
import { useTranslation } from 'react-i18next';

export function FormatHeader({format, formatId, disableDataAndUser, showDetails, showManagement}) {

    const { t } = useTranslation();
    const history = useHistory()
    const models = useModels()
    return <>
        {format && <>
            {format.formatStatus &&
                <>
                    <SecondaryOutlineBadge className="mr-1">{t("common.status")}</SecondaryOutlineBadge>
                    {renderUtils.renderStatus(format.formatStatus, "mr-2", false, t)}
                </>
            }
            {!disableDataAndUser && format.creationEndUsername &&
                <>
                    <SecondaryOutlineBadge className="mr-1">{t("common.user")}</SecondaryOutlineBadge><span
                    className="badge badge-primary mr-3">{format.creationEndUsername}</span>
                </>
            }
            {!disableDataAndUser && format.creationEndDate &&
                <>
                    <SecondaryOutlineBadge className="mr-1">{t("common.creation_date")}</SecondaryOutlineBadge><span
                    className="badge badge-primary mr-3">{format.creationEndDate}</span>
                </>
            }
        </>
        }
        <SecondaryOutlineBadge className="mr-1">ID</SecondaryOutlineBadge><span
        className="badge badge-primary mr-3">{formatId || format?.id}</span>
        {format?.formatStatus && showDetails &&
            <IconButton
                className={"mr-2"}
                variant={"outline-primary"}
                // className="btn-circle ml-1"
                onClick={() => history.push("/format/" + format.id)}
                tooltip={t("common.details")}
                icon={models.format.icon}
            />
        }
        {format?.formatStatus && format.formatStatus !== "WITHDRAWN" && format.formatStatus !== "CONFIGURATION" && showManagement &&
            <IconButton
                className={"mr-2"}
                variant={"outline-primary"}
                // className="btn-circle ml-1"
                onClick={() => history.push(models.management.url + "/" + format.id)}
                tooltip={models.management.title}
                disabled={format.formatStatus === "CONFIGURATION"}
                icon={"fa-bars-progress"}
            />
        }
        <QrCodeButton
            value={formatId || format?.id}
            filePrefix={"format"}
        />
    </>;
}